module.exports = __webpack_public_path__ + "img/Inspection4.0b4377fa.png";